import * as React from 'react';
import {useEffect, useRef} from 'react';
import {
    Button,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import DateTimePicker from '@mui/lab/DateTimePicker';
import config from '../../../app/config';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import Paper from '@mui/material/Paper';
import NavigateBeforeSharpIcon from '@mui/icons-material/NavigateBeforeSharp';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {AdminAPI} from '../admin_api';
import API from '../../../app/api';
import Hl7utils from './hl7utils';
import {copyToClipboard} from './hl7_console';
import useDict from '../../../hooks/useDict';
import FormControl from '@mui/material/FormControl';
import {setSnackbar} from '../../../store/reducers/globals';
import {setLoading} from '../../../store/reducers/patient';
import {useDispatch} from 'react-redux';
import Chip from '@mui/material/Chip';
import * as _get from 'lodash/get';
import {ErrorIconHL7, ArrowIconHL7, DatabaseIconHL7, DateIconHL7} from '../../../components/icons/icons';
import makeStyles from '@mui/styles/makeStyles';
import {styled} from '@mui/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import _ from 'lodash';
import {useWebSocket} from '../../../context/WebSocketProvider';

const StyledFormControl = styled(FormControl)(({theme}) => ({
    '&.MuiOutlinedInput-root': {
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.25)',
        '&.Mui-focused fieldset': {
            borderColor: '#448FFF',
        },
    },
    // '&.MuiInputBase-input':{
    //     borderRadius: "50%",
    //     '&:focus': {
    //         borderColor: '#448FFF',
    //     }
    // }
}));

const useStyles = makeStyles((theme) => ({
        typeSelect: {
            width: 150,
            height: 50,
            marginLeft: '15px',
        },
        typeSelectItem: {
            '&:hover': {
                backgroundColor: '#448FFF',
                color: 'white',
            },
        },
        agyleButton: {
            background: '#448FFF',
        },
        errorContainer: {
            cursor: 'pointer',
            backgroundColor: '#FFECEC',
            maxWidth: '100%',
            borderRadius: '7px',
            marginBottom: '10px',
        },
        errorIconOuter: {
            minWidth: '85px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: '10px',
            marginRight: '10px',
        },
        errorIconInner: {
            height: '40px',
            width: '40px',
            backgroundColor: 'white',
            borderRadius: '50%',
            paddingLeft: '10px',
            paddingTop: '10px',
            boxShadow: '0 0 10px red',
        },
        errorContainerText: {
            marginTop: '20px',
            marginRight: '20px',
            marginBottom: '20px',
            wordBreak: 'initial',
        },
        spaceBetween: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',

        },
        textWithArrow: {
            cursor: 'pointer',
            display: 'flex',
            gap: '5px',
        },
    }),
);

export const ColumnTypes = {
    TEXT: 1,
    ACTIONS: 2,
    CHEACKBOX: 3,
    FUNC:4
};

const columnsWidths = {
    'Info': '100px',
    'Date': '300px',
    'Created': '300px',
    'Type': '170px',
    'Hospital number': '170px',
    'Attendance': '200px',
    'System': '200px',
    'Version': '200px',
    'Actions': '200px',
    'Patient': '200px',
    'Status': '170px',
    'Last Send Time': '200px',
    'Last Status': '170px',
    'Hl7 Type': '170px',
};

function RowMessage(props) {
    const columns = props.columns;
    const row = props.row;
    const classes = useStyles();

    const dispatch = useDispatch();

    const [messageVisible, setMessageVisible] = React.useState(false);

    const [selected, setSelected] = React.useState(false);

    const handleAddToSelectRows = (row) => {
        setSelected(!selected);
    };

    useEffect(() => {
        if (props.handleAddRow && selected)
            props.handleAddRow(row);
        if (props.handleRemoveRow && !selected)
            props.handleRemoveRow(row);
    }, [selected]);

    const handleMessageClick = () => {
        setMessageVisible(!messageVisible);
    };

    const checkMessage = (msg, nm) => {
        switch (nm.key) {
            case 'Copy JSON':
                if (!msg)
                    return dispatch(setSnackbar({open: true, message: `No message to copy`, severity: 'error'}));
                return nm.props.onClick();

            case 'Show JSON':
                if (!msg)
                    return dispatch(setSnackbar({open: true, message: `No message to show`, severity: 'error'}));
                return nm.props.onClick();

            case 'Details':
                return nm.props.onClick();
        }
    };

    return (<React.Fragment>
        {/*<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>*/}
        <TableRow hover role="checkbox" tabIndex={-1} key={row.code + props.rowIndex}>
            {columns.map((column, index) => {
                switch (column.type) {

                    case ColumnTypes.TEXT:
                        const value = _get(row, column.value);
                        return (
                            <TableCell key={props.rowIndex + index + 'text'} align={column.align}>
                                {column.format
                                    ? column.format(value)
                                    : value}
                                {column.withMessage &&
                                    <div
                                        className={classes.textWithArrow}
                                        style={{color: row.errorMessage ? '#FF6868' : '#448FFF'}}
                                        onClick={() => {
                                            if (row.send && row.send.length > 0 && row.send[row.send.length - 1].hl7message) {
                                                handleMessageClick();
                                            } else if (row.message) {
                                                handleMessageClick();
                                            }
                                        }}
                                    >
                                        <Typography variant="body2" gutterBottom>
                                            Message
                                        </Typography>
                                        <ArrowIconHL7
                                            color={row.errorMessage ? '#FF6868' : '#448FFF'}
                                            sx={{fontSize: 20}}
                                            open={messageVisible}
                                        />
                                    </div>
                                }
                            </TableCell>
                        );

                    case ColumnTypes.ACTIONS:
                        let buttons = [];
                        column.actionList.forEach((action) => {
                            buttons.push(<Button key={action.buttonLabel}
                                                 onClick={() => action.callback(row)}>{action.buttonLabel}</Button>);
                        });

                        return (
                            <TableCell key={props.rowIndex + 'buttons'} align={column.align}>
                                <StyledFormControl className={classes.typeSelect}>
                                    <InputLabel>Select action</InputLabel>
                                    <Select
                                        input={<OutlinedInput/>}
                                    >
                                        {buttons.map((name) => {
                                            return (
                                                <MenuItem
                                                    className={classes.typeSelectItem}
                                                    key={name.key}
                                                    onClick={() => checkMessage(row.message, name)}
                                                    value="Select action"
                                                >
                                                    {name.key}
                                                </MenuItem>
                                            );
                                        })
                                        }
                                    </Select>
                                </StyledFormControl>
                            </TableCell>
                        );
                    case ColumnTypes.CHEACKBOX:
                        return (
                            <TableCell key={props.rowIndex + index + 'ch'} align={column.align || 'center'}
                                       sx={{borderLeft: row.errorMessage ? '2px solid red' : ''}}>
                                <Checkbox
                                    onChange={() => {
                                        handleAddToSelectRows(row);
                                    }}
                                    checked={selected}
                                    inputProps={{
                                        'aria-label': 'primary checkbox',
                                    }}
                                    color={'info'}
                                />
                            </TableCell>
                        );

                }

            })}
        </TableRow>

        {/*TODO*/}
        {/*Make check if other page than this item is on, if yes - make somehow to not render opened messages*/}

        {/*{messageVisible && <TableRow>*/}
        {/*    <TableCell style={{wordBreak: "break-all", paddingBottom: 0, paddingTop: 0 }} colSpan={8}>*/}

        {/*        <div style={{color: "red"}}>{row.errorMessage}</div>*/}
        {/*        <div>Messages</div>*/}
        {/*        {props.messagePath(row)}*/}

        {/*    </TableCell>*/}
        {/*</TableRow>}*/}
        {messageVisible && (
            <TableRow hover key={row._id}>
                <TableCell
                    style={{
                        wordBreak: 'break-all',
                        padding: '10px 40px 10px 50px',
                        borderLeft: row.errorMessage ? '2px solid red' : '',
                    }}
                    colSpan={8}
                    align="justify"
                >
                    {row.errorMessage && (<Grid container direction="row" className={classes.errorContainer}
                                                style={{color: row.error ? 'red' : 'blue'}}>
                        <Grid item xs={1} className={classes.errorIconOuter}>
                            <div className={classes.errorIconInner}>
                                <ErrorIconHL7/>
                            </div>
                        </Grid>
                        <Grid item xs={9} style={{display: 'flex'}}>
                            <Grid item xs={12} className={classes.errorContainerText}>
                                <Typography variant="subtitle2">Error</Typography>
                                <Grid item xs={12}>
                                    <Typography variant="body2" sx={{color: 'black'}}>{row.errorMessage}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>)}
                    <Grid container style={{marginBottom: '10px'}}>
                        <Typography variant="subtitle2" sx={{marginBottom: '10px'}}>Messages</Typography>
                        <Typography variant="body2">
                            {props.messagePath(row)}
                        </Typography>
                    </Grid>
                </TableCell>
            </TableRow>
        )}
    </React.Fragment>);
}

function Hl7Messages(props) {

    const isEyonix = process.env.BUILD_MODULE === "main";
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const controller = new AbortController();
    const classes = useStyles();

    const {manageSubscription, message} = useWebSocket();

    const [runSocket, setRunSocket] = React.useState(props.liveMessage);

    const [messageType] = useDict('HL7MessageTypes');

    const [messages, setMessages] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [sortSend, setSortSend] = React.useState(null);
    const [sortOrder, setSortOrder] = React.useState(false);

    const [selectedRows, setSelectedRows] = React.useState([]);

    const pageSize = 20;

    useEffect(() => {
        manageSubscription([props.webSocketChanel], runSocket);
    }, [runSocket]);

    useEffect(() => {
        if (props.columns.length) {
            let defaultSortItem = _.find(props.columns, {defaultSort: true});
            if (defaultSortItem) {
                setSortSend(defaultSortItem.value);
            } else {
                setSortSend('_createdDate');
            }
        }

    }, [props.columns]);

    const [searchCriteria, setSearchCriteria] = React.useState({
        searchFromDay: moment().subtract(1, 'week'),
        searchToDay: moment(),
        searchString: '',
        incomingSystem: null,
        hospitalNumber: '',
        attendanceId: '',
        messageType: '',
        searchErrors: false,
        searchErrorsPrepare: false,
        searchErrorsSend: false,
    });


    useEffect(() => {
        if (props.liveMessage) {
            setRunSocket(props.liveMessage);
            getHl7Message();
        } else {
            setRunSocket(props.liveMessage);
        }

    }, [props.liveMessage]);


    useEffect(() => {
        getHl7Message();
    }, [message]);


    const getFilter = () => {
        let filterchain = [];
        //let sfrom = (moment(searchCriteria.searchFromDay).add((moment(searchCriteria.searchFromDay).utcOffset()), 'm'));
        //let sto = (moment(searchCriteria.searchToDay).add((moment(searchCriteria.searchFromDay).utcOffset()), 'm'));
        let from = {_createdDate: {$gte: {$date: {$numberLong: `${moment(searchCriteria.searchFromDay).utc().valueOf()}`}}}};
        filterchain.push(from);
        let to = {_createdDate: {$lte: {$date: {$numberLong: `${moment(searchCriteria.searchToDay).utc().valueOf()}`}}}};
        filterchain.push(to);
        if (searchCriteria.searchString && searchCriteria.searchString.length) {
            let f = filterToRegex(searchCriteria.searchString);
            filterchain.push({message: {$regex: `${f}`, $options: 'i'}});
        }
        if (searchCriteria.incomingSystem && searchCriteria.incomingSystem.length) {
            let f = filterToRegex(searchCriteria.incomingSystem);
            filterchain.push({incomingSystem: {$regex: `${f}`, $options: 'i'}});
        }
        if (searchCriteria.hospitalNumber && searchCriteria.hospitalNumber.length) {
            let f = filterToRegex(searchCriteria.hospitalNumber);
            if (isRegex(searchCriteria.hospitalNumber)) {
                filterchain.push({hospitalNumber: {$regex: `${f}`, $options: 'i'}});
            } else {
                filterchain.push({hospitalNumber: f});
            }
        }
        if (searchCriteria.messageType && searchCriteria.messageType.length) {
            let f = filterToRegex(searchCriteria.messageType);
            if (isRegex(searchCriteria.messageType)) {
                filterchain.push({messageType: {$regex: `${f}`, $options: 'i'}});
            } else {
                filterchain.push({messageType: f});
            }
        }
        if (searchCriteria.attendanceId && searchCriteria.attendanceId.length) {
            filterchain.push({attendanceId: searchCriteria.attendanceId});
        }
        if (searchCriteria.searchErrors) {
            filterchain.push({error: true});
        }
        let filter = {$and: filterchain};
        return filter;
    };

    const getHl7Message = () => {
        if (sortSend) {
            dispatch(setLoading(true));
            getSetFilters();

            if (props.outcoming)
                getHL7outcomming();
            else
                getHL7Incomming();
        }
    };

    const getHL7outcomming = () => {
        let sort = (sortOrder ? '' : '!') + sortSend;
        if(isEyonix) {
            AdminAPI.getHl7SendLog(searchCriteria.messageType, moment.utc(searchCriteria.searchFromDay), moment.utc(searchCriteria.searchToDay),
                searchCriteria.hospitalNumber, searchCriteria.searchErrors, null, page, pageSize, sort, searchCriteria.searchString, searchCriteria.attendanceId).then(tableData => {
                if (tableData?.data?.__data) setMessages(tableData.data.__data);
            }).finally(() => {
                dispatch(setLoading(false));
            });
        }else {
            AdminAPI.getHl7SendLog(searchCriteria.messageType, searchCriteria.searchFromDay, searchCriteria.searchToDay,
                searchCriteria.hospitalNumber, searchCriteria.searchErrorsPrepare, searchCriteria.searchErrorsSend, page, pageSize, sort).then(tableData => {
                if (tableData?.data?.__data) setMessages(tableData.data.__data);
            }).finally(() => {
                dispatch(setLoading(false));
            });
        }
    };

    const getHL7Incomming = () => {
        AdminAPI.getTableData(props.table, controller.signal, getFilter(), page, pageSize, sortSend + ': ' + (sortOrder ? '1' : '-1')).then(tableData => {
            if (tableData) setMessages(tableData);
            dispatch(setLoading(false));
        }).finally(() => {
            dispatch(setLoading(false));
        });
    };

    const filterToRegex = (str) => {
        if (str && str.length > 0) {
            if (str[0] === '%') {
                str = '.*' + str.substr(1);
            }
            if (str[str.length - 1] === '%') {
                str = str.substr(0, str.length - 2) + '.*';
            }
        }
        return str;
    };

    const isRegex = (str) => {
        if (str && str.length > 0) {
            if (str[0] === '%') {
                return true;
            }
            if (str[str.length - 1] === '%') {
                return true;
            }
        }
        return false;
    };

    useEffect(() => {
        //getHl7Message();

        return () => {
            controller.abort();
        };
    }, []);

    const [filtersChip, setFilterChips] = React.useState([]);

    const applyFilter = () => {
        if (!page) {
            getHl7Message();
        } else
            setPage(0);
    };

    const getSetFilters = () => {
        let filters = [];

        if (searchCriteria.searchString) filters.push({filed: 'searchString', value: searchCriteria.searchString});
        if (searchCriteria.incomingSystem) filters.push({
            filed: 'incomingSystem',
            value: searchCriteria.incomingSystem,
        });
        if (searchCriteria.hospitalNumber) filters.push({
            filed: 'hospitalNumber',
            value: searchCriteria.hospitalNumber,
        });
        if (searchCriteria.attendanceId) filters.push({filed: 'attendanceId', value: searchCriteria.attendanceId});
        if (searchCriteria.messageType) filters.push({filed: 'messageType', value: searchCriteria.messageType});

        setFilterChips(filters);
    };

    useEffect(() => {
        if (doSearch.current) {
            applyFilter();
            doSearch.current = false;
        }
    }, [searchCriteria]);

    const doSearch = useRef(false);

    const handleDelete = (chip) => {
        doSearch.current = true;
        setSearchCriteria(prevState => ({...prevState, [chip.filed]: ''}));
    };

    const renderFilters = () => {
        return (<Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{padding: '40px', borderRadius: '5px', marginBottom: '10px', border: '1px solid #448FFF'}}
        >
            <Grid item xs={3}>
                <DateTimePicker
                    label={t('Date From')}
                    inputFormat={config.defaultDateTimeFormat}
                    inputVariant="outlined"
                    clearable={true}
                    ampm={false}
                    value={searchCriteria.searchFromDay}
                    onChange={(value) => {
                        setSearchCriteria(prevState => ({...prevState, searchFromDay: value}));
                    }}
                    renderInput={(inp) => <TextField style={{width: '100%', margin: 0}} {...inp}
                                                     size={props.size}/>}
                />
            </Grid>
            <Grid item xs={3}>
                <DateTimePicker
                    label={t('Date To')}
                    inputFormat={config.defaultDateTimeFormat}
                    inputVariant="outlined"
                    clearable={true}
                    ampm={false}
                    value={searchCriteria.searchToDay}
                    onChange={(value) => {
                        setSearchCriteria(prevState => ({...prevState, searchToDay: value}));
                    }}
                    renderInput={(inp) => <TextField style={{width: '100%', margin: 0}} {...inp}
                                                     size={props.size}/>}
                />
            </Grid>
            <Grid item xs={3}>
                <FormControl variant="outlined" size={'medium'} style={{width: '100%'}}>
                    <InputLabel>{t('Message Type')}</InputLabel>
                    <Select
                        label={t('Message Type')}
                        value={searchCriteria.messageType}
                        onChange={(event) => {
                            setSearchCriteria(prevState => ({...prevState, messageType: event.target.value}));
                        }}
                        fullWidth
                        renderValue={(selected) => {
                            return selected;
                        }}
                    >
                        {messageType.map((messageType, index) => (
                            <MenuItem
                                key={messageType.type + index}
                                value={messageType.type}
                                style={{display: 'flex', alignItems: 'center'}}
                            >
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <div>{messageType.type}</div>
                                </div>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>


            </Grid>
            <Grid item xs={3}>
                <TextField
                    name={'value'}
                    fullWidth
                    label={t('Incoming System')}
                    fullEvent={true}
                    onChange={(event) => {
                        setSearchCriteria(prevState => ({...prevState, incomingSystem: event.target.value}));
                    }}
                    value={searchCriteria.incomingSystem}
                    variant="outlined"
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    name={'value'}
                    fullWidth
                    label={t('Search')}
                    fullEvent={true}
                    onChange={(event) => {
                        setSearchCriteria(prevState => ({...prevState, searchString: event.target.value}));
                    }}
                    value={searchCriteria.searchString}
                    variant="outlined"
                />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    name={'value'}
                    label={t('Hospital Number')}
                    fullEvent={true}
                    fullWidth
                    onChange={(event) => {
                        setSearchCriteria(prevState => ({...prevState, hospitalNumber: event.target.value}));
                    }}
                    value={searchCriteria.hospitalNumber}
                    variant="outlined"
                />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    name={'value'}
                    label={((props.outcoming && isEyonix) ? t('Message ID') : t('Attendance ID'))}
                    fullWidth
                    fullEvent={true}
                    onChange={(event) => {
                        setSearchCriteria(prevState => ({...prevState, attendanceId: event.target.value}));
                    }}
                    value={searchCriteria.attendanceId}
                    variant="outlined"
                />
            </Grid>
            {(!props.outcoming || isEyonix) && <Grid item xs={12}>
                <FormControlLabel
                    label={t('Only Errors')}
                    labelPlacement={'end'}
                    value={searchCriteria.searchErrors}
                    control={
                        <Checkbox
                            onChange={(event) => {
                                setSearchCriteria(prevState => ({...prevState, searchErrors: event.target.checked}));
                            }
                            }
                            checked={searchCriteria.searchErrors}
                            inputProps={{
                                'aria-label': 'primary checkbox',
                            }}
                            color={'error'}
                        />
                    }
                />
            </Grid>
            }
            {(props.outcoming && !isEyonix) && <Grid item xs={12}>
                <FormControlLabel
                    label={t('Only prepare Errors')}
                    labelPlacement={'end'}
                    control={
                        <Checkbox
                            onChange={(event) => {
                                setSearchCriteria(prevState => ({
                                    ...prevState,
                                    searchErrorsPrepare: event.target.checked,
                                }));
                            }
                            }
                            checked={searchCriteria.searchErrorsPrepare}
                            inputProps={{
                                'aria-label': 'primary checkbox',
                            }}
                            color={'error'}
                        />
                    }
                />
                <FormControlLabel
                    label={t('Only Send Errors')}
                    labelPlacement={'end'}
                    control={
                        <Checkbox
                            onChange={(event) => {
                                setSearchCriteria(prevState => ({
                                    ...prevState,
                                    searchErrorsSend: event.target.checked,
                                }));
                            }
                            }
                            checked={searchCriteria.searchErrorsSend}
                            inputProps={{
                                'aria-label': 'primary checkbox',
                            }}
                            color={'error'}
                        />
                    }
                />
            </Grid>
            }
            <Grid item xs={12}>
                <Button variant="contained" className={classes.agyleButton} onClick={applyFilter}>Apply</Button>
            </Grid>
            <Grid item xs={12}>
                {filtersChip.map((filter) => {
                    return <Chip label={filter.value} onDelete={() => handleDelete(filter)}/>;
                })}
            </Grid>
        </Grid>);
    };


    const addRow = (row) => {
        setSelectedRows((prRows) => ([...prRows, row]));
    };

    const removeRow = (row) => {
        let selectedRowsTmp = selectedRows.filter(item => item !== row);
        setSelectedRows(selectedRowsTmp);
    };

    useEffect(() => {
        if (sortSend)
            getHl7Message();
    }, [sortSend, sortOrder, page]);


    const handleChangeNextPage = () => {
        setPage(page + 1);
    };

    const handleChangePrevPage = () => {
        setPage(page - 1);
    };

    const copyRowsMessage = () => {
        let stringToCopy = '';
        let count = 0;
        selectedRows.forEach((r) => {
            if (r.message) {
                if (stringToCopy.length > 0) {
                    stringToCopy = stringToCopy + '\r\n\r\n';
                }
                let pm = Hl7utils.parseMessages(r.message);
                if (pm.length > 0) {
                    stringToCopy = stringToCopy + pm[0];
                } else {
                    stringToCopy = stringToCopy + r.message;
                }
                count++;

            }
        });

        copyToClipboard(stringToCopy);
        dispatch(setSnackbar({type: 'info', message: `${count} message/s has been copied!`}));
    };

    const resendMessages = () => {
        let promises = [];

        selectedRows.forEach((row) => {
            promises.push(API.sendMessageHL7(row.message, controller.signal));
        });

        Promise.all(promises).then((values) => {
            values.forEach((val) => {
                if (val.status === 'ok')
                    dispatch(setSnackbar({type: 'info', message: ` The message has been resent!`}));
                else
                    dispatch(setSnackbar({type: 'error', message: ` The message was not sent!`}));
            });
        });

    };

    const getColumnWidth = column => (columnsWidths[column?.description] || '256px');


    const handleSetSort = (column) => {
        if (column.value === sortSend) {
            setSortOrder(!sortOrder);
        } else {
            setSortSend(column.value);
        }
    };

    const getSortIcon = (columnName) => {
        if (columnName !== sortSend) return '';
        if (sortOrder) return <ArrowDropDownIcon/>;
        return <ArrowDropUpIcon/>;

    };
    return (<div>
        {!props.filterHidden && renderFilters()}
        {!props.filterHidden && selectedRows.length > 0 && <React.Fragment>
            <Button className={classes.agyleButton}
                    onClick={copyRowsMessage}
                    size="small"
                    color="primary"
                    variant="contained">
                {t('copy')}
            </Button>
            <Button className={classes.agyleButton}
                    onClick={resendMessages}
                    size="small"
                    color="primary"
                    variant="contained">
                {t('resend')}
            </Button>
        </React.Fragment>}

        <Paper sx={{width: '100%', overflow: 'hidden', mt: 4}}>
            <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead key={'HEAD'}>
                        <TableRow>
                            {props.columns.map((column, indexColumn) => {
                                return (
                                    <TableCell
                                        key={indexColumn + 'Hasd'}
                                        align={column.align}
                                        style={{
                                            minWidth: column.minWidth,
                                            width: column.maxWidth || getColumnWidth(column),
                                            border: '1px solid #80808035',
                                        }}
                                    >
                                        <Grid container justifyContent="space-between">
                                            <Typography variant="subtitle2"
                                                        color="textSecondary"
                                                        style={{cursor: column.sort ? 'pointer' : ''}}
                                                        onClick={() => {
                                                            if (column.sort) {
                                                                handleSetSort(column);
                                                            }
                                                        }}>
                                                <div style={{display: 'flex'}}>
                                                    {column.description} {getSortIcon(column.value)}
                                                </div>

                                            </Typography>
                                            {indexColumn === props.columns.length - 1 &&
                                                <DatabaseIconHL7 onClick={props.openColumnManager}/>}
                                            {column.name === 'dateTime' && <DateIconHL7/>}
                                        </Grid>
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {messages?.map((row, rowIndex) => {
                            // console.log("test", row);
                            return <React.Fragment key={rowIndex + 'div'}>
                                <RowMessage columns={props.columns}
                                            messagePath={props.messagePath}
                                            row={row} handleAddRow={addRow}
                                            rowIndex={rowIndex}
                                            outcoming={props.outcoming || false}
                                            handleRemoveRow={removeRow}/>
                            </React.Fragment>;
                        })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={8}>
                                Page: {page + 1}
                                <IconButton size="small"
                                            disabled={page < 1}
                                            onClick={handleChangePrevPage}>
                                    <NavigateBeforeSharpIcon fontSize="small"/>
                                </IconButton>
                                <IconButton size="small"
                                            disabled={messages.length < pageSize - 1}
                                            onClick={handleChangeNextPage}>
                                    <NavigateNextIcon fontSize="small"/>
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
        </Paper>

    </div>);
}

export default Hl7Messages;